import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"
import { useUserSettingsOfficesGroup, useUserSettingsOfficesGroupValidator } from "../../@hooks"


export default function UserSettingTierDrawerSubmit() {
	const { isLoading, handleSubmitOfficesGroupFormData } = useUserSettingsOfficesGroup()
	const { isValid } = useUserSettingsOfficesGroupValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitOfficesGroupFormData}
	>
		Save
	</ButtonLoadingSeeker>
}